import { APIuuid, IAPIData } from '@shared/interfaces/api.interface';
import { LeadTypeNotification as ILeadTypeNotification } from '@shared/interfaces/setting.interface';

export class LeadTypeNotification implements ILeadTypeNotification {
  public static readonly TYPE: string = String('LeadTypeNotification');

  public id: APIuuid;
  public send_to_root: boolean;
  public send_to_assigned: boolean;
  public send_to_custom: boolean;
  public custom_emails: string | null;

  constructor(partial: Partial<ILeadTypeNotification>) {
    Object.assign(this, partial);
  }

  public get apiData(): IAPIData {
    return {
      data: {
        type: LeadTypeNotification.TYPE,
        id: this.id,
        attributes: {
          send_to_root: this.send_to_root,
          send_to_assigned: this.send_to_assigned,
          send_to_custom: this.send_to_custom,
          custom_emails: this.custom_emails
        }
      }
    } as IAPIData;
  }

  public static fromAPI(res: IAPIData): ILeadTypeNotification {
    const data = res.data;
    if (!(data && data.type === LeadTypeNotification.TYPE)) {
      throw new Error(
        `There was a problem parsing ${LeadTypeNotification.TYPE} API data`
      );
    }

    return new LeadTypeNotification({
      id: data.id,
      ...data.attributes
    });
  }
}
